import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const NotProvisionedEmptyState = ({ height = 93, width = 114, ...props }: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 114 93" fill="none" {...props}>
    <path
      d="M108.2 55.2557C108.201 47.6143 106.492 40.0696 103.197 33.1749C99.9026 26.2802 95.1066 20.2103 89.1608 15.4104C83.215 10.6106 76.2702 7.20244 68.8358 5.436C61.4014 3.66956 53.6659 3.5896 46.1965 5.20198C38.7272 6.81437 31.7134 10.0782 25.6697 14.7541C19.626 19.4301 14.7055 25.3995 11.2692 32.2246C7.83289 39.0498 5.96784 46.5575 5.81086 54.1973C5.65387 61.8371 7.20892 69.4152 10.362 76.3757H103.638C106.65 69.7426 108.206 62.5408 108.2 55.2557Z"
      fill="#F5F4F4"
    />
    <path
      d="M7.08008 76.3757H106.92"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.32007 76.3757H4.52007"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M109.48 76.3757H112.68"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.4417 42.4993L49.2983 48.0788C49.8522 48.3396 50.3205 48.7526 50.6484 49.2696C50.9764 49.7866 51.1505 50.3862 51.1504 50.9985V76.3681H37.4417V42.4993Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.3042 42.4993H9.21778C8.79004 42.4993 8.37982 42.6692 8.07736 42.9716C7.7749 43.2741 7.60498 43.6843 7.60498 44.1121V76.3681H49.5378L44.8965 43.8881C44.8428 43.5036 44.6522 43.1514 44.3597 42.8963C44.0672 42.6411 43.6924 42.5002 43.3042 42.4993Z"
      fill="#C2F0FC"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M10.8306 45.7249H33.4098V68.3041H10.8306V45.7249Z" fill="white" />
    <path
      d="M22.9265 48.144H30.9905V62.6592H22.9265V48.144Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5393 52.176C24.5393 52.8176 24.7942 53.433 25.2479 53.8867C25.7016 54.3404 26.3169 54.5952 26.9585 54.5952C27.6001 54.5952 28.2155 54.3404 28.6691 53.8867C29.1228 53.433 29.3777 52.8176 29.3777 52.176C29.3777 51.5344 29.1228 50.9191 28.6691 50.4654C28.2155 50.0117 27.6001 49.7568 26.9585 49.7568C26.3169 49.7568 25.7016 50.0117 25.2479 50.4654C24.7942 50.9191 24.5393 51.5344 24.5393 52.176Z"
      fill="#FFF8D9"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.5393 58.6272C24.5393 59.2688 24.7942 59.8842 25.2479 60.3378C25.7016 60.7915 26.3169 61.0464 26.9585 61.0464C27.6001 61.0464 28.2155 60.7915 28.6691 60.3378C29.1228 59.8842 29.3777 59.2688 29.3777 58.6272C29.3777 57.9856 29.1228 57.3703 28.6691 56.9166C28.2155 56.4629 27.6001 56.208 26.9585 56.208C26.3169 56.208 25.7016 56.4629 25.2479 56.9166C24.7942 57.3703 24.5393 57.9856 24.5393 58.6272Z"
      fill="#E6FFF7"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8974 63.4721H10.8306V60.2465H19.2018C19.3393 60.2463 19.4746 60.2814 19.5948 60.3483C19.715 60.4152 19.8161 60.5117 19.8884 60.6287C19.9608 60.7457 20.002 60.8793 20.0082 61.0167C20.0143 61.1541 19.9853 61.2908 19.9237 61.4138L19.34 62.5812C19.2061 62.849 19.0002 63.0743 18.7454 63.2317C18.4905 63.389 18.1969 63.4723 17.8974 63.4721Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8306 45.7249H33.4098V68.3041H10.8306V45.7249Z"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8306 52.176C10.8306 52.176 11.6075 57.4176 16.0722 57.4176C17.3463 57.4405 18.6117 57.2024 19.7905 56.7182C20.9692 56.2339 22.0365 55.5136 22.9266 54.6016"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8306 49.7568C10.8306 49.7568 11.5346 54.5952 15.669 54.5952C18.2756 54.5324 20.8035 53.6897 22.9266 52.176"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.6353 51.3696H41.4737"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.6353 57.0144H42.2801"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.6353 62.6592H43.0865"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.6353 68.3041H43.8929"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.9104 88.3642C20.9104 88.9257 23.9583 89.4642 29.3836 89.8612C34.8089 90.2583 42.1672 90.4813 49.8397 90.4813C57.5122 90.4813 64.8705 90.2583 70.2958 89.8612C75.7211 89.4642 78.769 88.9257 78.769 88.3642C78.769 87.8027 75.7211 87.2642 70.2958 86.8672C64.8705 86.4701 57.5122 86.2471 49.8397 86.2471C42.1672 86.2471 34.8089 86.4701 29.3836 86.8672C23.9583 87.2642 20.9104 87.8027 20.9104 88.3642Z"
      fill="#F5F4F4"
    />
    <path
      d="M80.8875 88.3642C80.8875 88.9257 81.9281 89.4642 83.7806 89.8612C85.633 90.2583 88.1455 90.4813 90.7652 90.4813C93.3849 90.4813 95.8974 90.2583 97.7498 89.8612C99.6023 89.4642 100.643 88.9257 100.643 88.3642C100.643 87.8027 99.6023 87.2642 97.7498 86.8672C95.8974 86.4701 93.3849 86.2471 90.7652 86.2471C88.1455 86.2471 85.633 86.4701 83.7806 86.8672C81.9281 87.2642 80.8875 87.8027 80.8875 88.3642Z"
      fill="#F5F4F4"
    />
    <path
      d="M104.232 47.5578C105.972 48.7754 107.368 50.4217 108.285 52.3373C109.202 54.2528 109.609 56.3727 109.466 58.4916C109.188 61.6663 107.72 64.6186 105.357 66.7563C102.993 68.8941 99.9089 70.0592 96.7223 70.018H61.5774C58.3906 70.0592 55.3061 68.8941 52.9424 66.7564C50.5787 64.6187 49.1106 61.6664 48.8324 58.4916C48.6901 56.3726 49.0973 54.2528 50.0144 52.3373C50.9316 50.4218 52.3277 48.7755 54.0676 47.5578C56.2094 46.0995 57.9607 44.1382 59.1683 41.8456C60.3758 39.5531 61.0026 36.9994 60.9937 34.4084L60.8017 21.3319C60.7815 18.9098 61.241 16.5077 62.1539 14.2642C63.0668 12.0206 64.4149 9.98004 66.1205 8.26018C67.826 6.54032 69.8553 5.17521 72.0911 4.24362C74.327 3.31203 76.7251 2.8324 79.1473 2.8324C81.5694 2.8324 83.9676 3.31203 86.2035 4.24362C88.4393 5.17521 90.4686 6.54032 92.1741 8.26018C93.8797 9.98004 95.2278 12.0206 96.1407 14.2642C97.0535 16.5077 97.5131 18.9098 97.4929 21.3319L97.3009 34.4084C97.2926 36.9999 97.9202 39.5539 99.1286 41.8464C100.337 44.139 102.089 46.1001 104.232 47.5578Z"
      fill="#FDF5FF"
    />
    <path
      d="M104.232 47.5578C105.972 48.7754 107.368 50.4217 108.285 52.3373C109.202 54.2528 109.609 56.3727 109.466 58.4916C109.188 61.6663 107.72 64.6186 105.357 66.7563C102.993 68.8941 99.9089 70.0592 96.7223 70.018H61.5774C58.3906 70.0592 55.3061 68.8941 52.9424 66.7564C50.5787 64.6187 49.1106 61.6664 48.8324 58.4916C48.6901 56.3726 49.0973 54.2528 50.0144 52.3373C50.9316 50.4218 52.3277 48.7755 54.0676 47.5578C56.2094 46.0995 57.9607 44.1382 59.1683 41.8456C60.3758 39.5531 61.0026 36.9994 60.9937 34.4084L60.8017 21.3319C60.7815 18.9098 61.241 16.5077 62.1539 14.2642C63.0668 12.0206 64.4149 9.98004 66.1205 8.26018C67.826 6.54032 69.8553 5.17521 72.0911 4.24362C74.327 3.31203 76.7251 2.8324 79.1473 2.8324C81.5694 2.8324 83.9676 3.31203 86.2035 4.24362C88.4393 5.17521 90.4685 6.54032 92.1741 8.26018C93.8797 9.98004 95.2278 12.0206 96.1407 14.2642C97.0535 16.5077 97.5131 18.9098 97.4929 21.3319L97.3009 34.4084C97.2926 36.9999 97.9202 39.5539 99.1286 41.8464C100.337 44.139 102.089 46.1001 104.232 47.5578V47.5578Z"
      stroke="#6A266D"
      strokeWidth="1.28"
    />
    <path
      d="M101.021 65.785C101.043 62.8985 100.493 60.0362 99.4039 57.363C98.3146 54.6898 96.7069 52.2587 94.6736 50.2098C92.6403 48.1608 90.2215 46.5346 87.5568 45.4249C84.892 44.3151 82.034 43.7438 79.1474 43.7438C76.2607 43.7438 73.4027 44.3151 70.7379 45.4249C68.0732 46.5346 65.6544 48.1608 63.6211 50.2098C61.5878 52.2587 59.9801 54.6898 58.8908 57.363C57.8015 60.0362 57.252 62.8985 57.2741 65.785V67.9009C57.2741 68.2743 57.4224 68.6324 57.6865 68.8965C57.9505 69.1605 58.3087 69.3089 58.6821 69.3089H65.7387V76.3642H92.5534V69.3127H99.6101C99.9835 69.3127 100.342 69.1644 100.606 68.9003C100.87 68.6363 101.018 68.2781 101.018 67.9047L101.021 65.785Z"
      fill="#FFF8D9"
    />
    <path
      d="M101.021 65.785C101.043 62.8985 100.493 60.0362 99.4039 57.363C98.3146 54.6898 96.7069 52.2587 94.6736 50.2098C92.6403 48.1608 90.2215 46.5346 87.5568 45.4249C84.892 44.3151 82.034 43.7438 79.1474 43.7438C76.2607 43.7438 73.4027 44.3151 70.7379 45.4249C68.0732 46.5346 65.6544 48.1608 63.6211 50.2098C61.5878 52.2587 59.9801 54.6898 58.8908 57.363C57.8015 60.0362 57.252 62.8985 57.2741 65.785V67.9009C57.2741 68.2743 57.4224 68.6324 57.6865 68.8965C57.9505 69.1605 58.3087 69.3089 58.6821 69.3089H65.7387V76.3642H92.5534V69.3127H99.6101C99.9835 69.3127 100.342 69.1644 100.606 68.9003C100.87 68.6363 101.018 68.2781 101.018 67.9047L101.021 65.785Z"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.7412 63.6678V76.368"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M92.5535 63.6678V76.368"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.1606 84.13C43.1617 83.1947 43.5337 82.298 44.195 81.6367C44.8563 80.9753 45.753 80.6034 46.6883 80.6023H48.0963C50.9023 80.599 53.5924 79.4827 55.5764 77.4985C57.5604 75.5142 58.6763 72.824 58.6794 70.018V69.3127H65.736V70.018C65.7313 74.6948 63.872 79.1789 60.566 82.4868C57.2599 85.7948 52.777 87.6567 48.1002 87.6641H46.6922C46.2282 87.6641 45.7687 87.5727 45.3401 87.395C44.9115 87.2174 44.5221 86.957 44.1941 86.6288C43.8661 86.3006 43.6061 85.911 43.4287 85.4823C43.2514 85.0535 43.1603 84.594 43.1606 84.13Z"
      fill="#FFF5F5"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.0308 84.13C77.0318 83.1947 77.4038 82.298 78.0651 81.6367C78.7265 80.9753 79.6232 80.6034 80.5584 80.6023H81.9664C84.7726 80.5993 87.463 79.4832 89.4473 77.4989C91.4316 75.5146 92.5477 72.8242 92.5508 70.018V69.3127H99.6074V70.018C99.6027 74.6953 97.7431 79.1797 94.4365 82.4877C91.1299 85.7958 86.6462 87.6573 81.969 87.6641H80.561C80.0971 87.6639 79.6378 87.5724 79.2093 87.3947C78.7809 87.217 78.3916 86.9566 78.0638 86.6284C77.7359 86.3002 77.476 85.9106 77.2987 85.482C77.1215 85.0533 77.0304 84.5939 77.0308 84.13Z"
      fill="#FFF5F5"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.2084 44.6164C74.1979 45.2717 74.3178 45.9225 74.5613 46.5309C74.8047 47.1394 75.1669 47.6933 75.6265 48.1605C76.0862 48.6276 76.6342 48.9986 77.2387 49.2518C77.8431 49.505 78.4919 49.6354 79.1473 49.6354C79.8026 49.6354 80.4514 49.505 81.0559 49.2518C81.6604 48.9986 82.2084 48.6276 82.6681 48.1605C83.1277 47.6933 83.4898 47.1394 83.7333 46.5309C83.9768 45.9225 84.0967 45.2717 84.0862 44.6164V39.6769H74.2084V44.6164Z"
      fill="#FFF5F5"
    />
    <path
      d="M74.2084 44.6164V39.6769H84.0862V44.6164C84.0967 45.2717 83.9768 45.9225 83.7333 46.5309C83.4898 47.1394 83.1277 47.6933 82.6681 48.1605C82.2084 48.6276 81.6604 48.9986 81.0559 49.2518C80.4514 49.505 79.8026 49.6354 79.1473 49.6354C78.4919 49.6354 77.8431 49.505 77.2387 49.2518C76.6342 48.9986 76.0862 48.6276 75.6265 48.1605C75.1669 47.6933 74.8047 47.1394 74.5613 46.5309C74.3178 45.9225 74.1979 45.2717 74.2084 44.6164V44.6164Z"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M96.0811 27.6832C96.0771 28.4288 95.7791 29.1427 95.2519 29.6699C94.7247 30.1972 94.0108 30.4952 93.2652 30.4992C93.2079 30.4967 93.1512 30.4872 93.0962 30.471C92.5997 33.8138 90.9187 36.867 88.3595 39.0741C85.8003 41.2813 82.5333 42.4955 79.1538 42.4955C75.7743 42.4955 72.5073 41.2813 69.9481 39.0741C67.3889 36.867 65.7079 33.8138 65.2114 30.471C65.156 30.4872 65.0988 30.4967 65.0412 30.4992C64.2926 30.4992 63.5747 30.2018 63.0454 29.6725C62.5161 29.1432 62.2187 28.4253 62.2188 27.6768C62.2187 26.9282 62.5161 26.2104 63.0454 25.681C63.5747 25.1517 64.2926 24.8544 65.0412 24.8544C68.8784 20.6465 71.1249 15.2302 71.3925 9.54175C71.3925 9.54175 71.5896 24.8544 79.5205 24.8544L78.4274 21.104C79.3665 22.8279 80.7724 24.2523 82.4839 25.2138C84.1955 26.1753 86.1434 26.635 88.1042 26.5401H93.3266L93.2549 24.8608C93.6261 24.8594 93.9939 24.9315 94.3372 25.0728C94.6804 25.2141 94.9924 25.4219 95.255 25.6842C95.5177 25.9465 95.7259 26.2582 95.8677 26.6012C96.0094 26.9443 96.082 27.312 96.0811 27.6832Z"
      fill="#FFF5F5"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M74.8894 34.4519C76.0343 35.5413 77.5542 36.1489 79.1345 36.1489C80.7149 36.1489 82.2348 35.5413 83.3796 34.4519"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.6305 26.2714C75.4544 25.8538 75.1591 25.4975 74.7815 25.247C74.4039 24.9964 73.9608 24.8628 73.5076 24.8628C73.0545 24.8628 72.6114 24.9964 72.2338 25.247C71.8562 25.4975 71.5609 25.8538 71.3848 26.2714"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M69.2688 30.8576C69.2688 31.3254 69.4546 31.774 69.7854 32.1048C70.1162 32.4356 70.5648 32.6214 71.0326 32.6214C71.5004 32.6214 71.9491 32.4356 72.2799 32.1048C72.6106 31.774 72.7965 31.3254 72.7965 30.8576C72.7965 30.3898 72.6106 29.9412 72.2799 29.6104C71.9491 29.2796 71.5004 29.0938 71.0326 29.0938C70.5648 29.0938 70.1162 29.2796 69.7854 29.6104C69.4546 29.9412 69.2688 30.3898 69.2688 30.8576Z"
      fill="#FBC3CB"
    />
    <path
      d="M85.4968 30.8576C85.4968 31.3254 85.6827 31.774 86.0134 32.1048C86.3442 32.4356 86.7929 32.6214 87.2607 32.6214C87.7285 32.6214 88.1771 32.4356 88.5079 32.1048C88.8387 31.774 89.0245 31.3254 89.0245 30.8576C89.0245 30.3898 88.8387 29.9412 88.5079 29.6104C88.1771 29.2796 87.7285 29.0938 87.2607 29.0938C86.7929 29.0938 86.3442 29.2796 86.0134 29.6104C85.6827 29.9412 85.4968 30.3898 85.4968 30.8576Z"
      fill="#FBC3CB"
    />
    <path
      d="M64.3292 34.032H62.2121C62.1194 34.0322 62.0277 34.0141 61.942 33.9787C61.8564 33.9433 61.7786 33.8914 61.713 33.8258C61.6475 33.7603 61.5956 33.6825 61.5602 33.5968C61.5248 33.5112 61.5067 33.4194 61.5068 33.3267V23.449C61.5067 23.3563 61.5248 23.2644 61.5602 23.1787C61.5955 23.093 61.6474 23.0151 61.713 22.9495C61.7785 22.8838 61.8563 22.8318 61.9419 22.7962C62.0276 22.7607 62.1194 22.7424 62.2121 22.7424H64.3292C64.7027 22.7424 65.0608 22.8908 65.3248 23.1548C65.5889 23.4189 65.7372 23.777 65.7372 24.1504V32.624C65.7372 32.9975 65.5889 33.3556 65.3248 33.6196C65.0608 33.8837 64.7027 34.032 64.3292 34.032Z"
      fill="#B56DC6"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.6846 32.6241H61.5006V24.1543H58.6846C58.3112 24.1543 57.9531 24.3026 57.689 24.5667C57.425 24.8307 57.2766 25.1889 57.2766 25.5623V31.2161C57.2766 31.5895 57.425 31.9476 57.689 32.2117C57.9531 32.4757 58.3112 32.6241 58.6846 32.6241Z"
      fill="#FEE5E9"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M93.9639 34.032H96.081C96.2681 34.032 96.4475 33.9577 96.5797 33.8255C96.712 33.6932 96.7863 33.5138 96.7863 33.3267V23.449C96.7863 23.2618 96.712 23.0823 96.5798 22.9498C96.4476 22.8174 96.2682 22.7428 96.081 22.7424H93.9639C93.5905 22.7424 93.2324 22.8908 92.9683 23.1548C92.7042 23.4189 92.5559 23.777 92.5559 24.1504V32.624C92.5559 32.9975 92.7042 33.3556 92.9683 33.6196C93.2324 33.8837 93.5905 34.032 93.9639 34.032Z"
      fill="#B56DC6"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M101.021 31.2161C101.021 31.5895 100.872 31.9476 100.608 32.2117C100.344 32.4757 99.9861 32.6241 99.6126 32.6241H96.7966V24.1543H99.6126C99.9861 24.1543 100.344 24.3026 100.608 24.5667C100.872 24.8307 101.021 25.1889 101.021 25.5623V31.2161Z"
      fill="#FEE5E9"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M98.1983 24.1543C98.1983 21.6524 97.7055 19.175 96.7481 16.8636C95.7906 14.5521 94.3873 12.4519 92.6182 10.6828C90.8491 8.91372 88.7489 7.51039 86.4374 6.55296C84.126 5.59554 81.6486 5.10275 79.1467 5.10275C76.6449 5.10275 74.1675 5.59554 71.856 6.55296C69.5446 7.51039 67.4444 8.91372 65.6753 10.6828C63.9062 12.4519 62.5029 14.5521 61.5454 16.8636C60.588 19.175 60.0952 21.6524 60.0952 24.1543V20.6266C60.0952 18.1247 60.588 15.6473 61.5454 13.3359C62.5029 11.0245 63.9062 8.92423 65.6753 7.15514C67.4444 5.38604 69.5446 3.98271 71.856 3.02528C74.1675 2.06786 76.6449 1.57507 79.1467 1.57507C81.6486 1.57507 84.126 2.06786 86.4374 3.02528C88.7489 3.98271 90.8491 5.38604 92.6182 7.15514C94.3873 8.92423 95.7906 11.0245 96.7481 13.3359C97.7055 15.6473 98.1983 18.1247 98.1983 20.6266V24.1543Z"
      fill="#FEE5E9"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M72.7965 42.4992H69.9805C69.6071 42.4992 69.249 42.3509 68.9849 42.0868C68.7209 41.8228 68.5725 41.4647 68.5725 41.0912C68.5725 40.7178 68.7209 40.3597 68.9849 40.0956C69.249 39.8316 69.6071 39.6832 69.9805 39.6832H72.7965C73.1699 39.6832 73.5281 39.8316 73.7921 40.0956C74.0562 40.3597 74.2045 40.7178 74.2045 41.0912C74.2045 41.4647 74.0562 41.8228 73.7921 42.0868C73.5281 42.3509 73.1699 42.4992 72.7965 42.4992Z"
      fill="#B56DC6"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M68.5624 41.0887H65.7464C64.2494 41.0883 62.8138 40.4935 61.7553 39.435C60.6967 38.3764 60.1019 36.9409 60.1016 35.4439V32.624"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M75.4384 84.6036C75.384 84.2737 75.214 83.974 74.9588 83.758C74.7037 83.542 74.38 83.4239 74.0457 83.4247H25.64C25.3059 83.4242 24.9825 83.5425 24.7276 83.7584C24.4728 83.9744 24.303 84.2739 24.2486 84.6036L24.0131 86.0116C23.9774 86.2139 23.9865 86.4216 24.0396 86.6201C24.0927 86.8186 24.1886 87.003 24.3206 87.1605C24.4526 87.3179 24.6174 87.4446 24.8035 87.5316C24.9897 87.6186 25.1926 87.6638 25.398 87.6641H74.28C74.4849 87.6645 74.6875 87.6202 74.8736 87.5342C75.0597 87.4482 75.2247 87.3226 75.3572 87.1662C75.4897 87.0098 75.5865 86.8264 75.6407 86.6287C75.695 86.4311 75.7054 86.2239 75.6713 86.0218L75.4384 84.6036Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.0829 80.6023H27.2605C27.0734 80.6023 26.894 80.6766 26.7617 80.8089C26.6295 80.9411 26.5552 81.1205 26.5552 81.3076V83.4247H30.7881V81.3076C30.7881 81.1205 30.7138 80.9411 30.5816 80.8089C30.4493 80.6766 30.2699 80.6023 30.0829 80.6023Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.1395 80.6023H34.3235C34.1363 80.6023 33.9568 80.6766 33.8243 80.8088C33.6919 80.941 33.6173 81.1204 33.6169 81.3076V83.4247H37.8512V81.3076C37.8512 81.2144 37.8327 81.1222 37.7969 81.0362C37.761 80.9502 37.7085 80.8722 37.6424 80.8066C37.5762 80.741 37.4977 80.6892 37.4114 80.6542C37.3251 80.6191 37.2327 80.6015 37.1395 80.6023Z"
      fill="#FFF5F5"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.2 80.6023H41.3725C41.1855 80.6023 41.0061 80.6766 40.8738 80.8089C40.7415 80.9411 40.6672 81.1205 40.6672 81.3076V83.4247H44.9002V81.3076C44.9002 81.1214 44.8266 80.9428 44.6954 80.8107C44.5643 80.6786 44.3862 80.6036 44.2 80.6023Z"
      fill="#FFF8D9"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.2516 80.6023H48.4241C48.2369 80.6023 48.0574 80.6766 47.9249 80.8088C47.7925 80.941 47.7179 81.1204 47.7175 81.3076V83.4247H51.9569V81.3076C51.9569 81.1205 51.8826 80.9411 51.7503 80.8089C51.6181 80.6766 51.4387 80.6023 51.2516 80.6023Z"
      fill="#FEE5E9"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M58.3069 80.6023H55.4909C55.3983 80.6023 55.3066 80.6206 55.221 80.656C55.1355 80.6915 55.0577 80.7434 54.9922 80.8089C54.9267 80.8744 54.8748 80.9521 54.8393 81.0377C54.8039 81.1233 54.7856 81.215 54.7856 81.3076V83.4247H59.0186V81.3076C59.0186 81.2144 59.0002 81.1222 58.9643 81.0362C58.9285 80.9502 58.8759 80.8722 58.8098 80.8066C58.7436 80.741 58.6651 80.6892 58.5788 80.6542C58.4925 80.6191 58.4001 80.6015 58.3069 80.6023Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M65.3636 80.6023H62.5476C62.3605 80.6023 62.1809 80.6766 62.0485 80.8088C61.916 80.941 61.8414 81.1204 61.8411 81.3076V83.4247H66.0753V81.3076C66.0753 81.2144 66.0569 81.1222 66.021 81.0362C65.9852 80.9502 65.9326 80.8722 65.8665 80.8066C65.8003 80.741 65.7218 80.6892 65.6355 80.6542C65.5492 80.6191 65.4568 80.6015 65.3636 80.6023Z"
      fill="#E6FFF7"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M72.419 80.6023H69.603C69.4159 80.6023 69.2365 80.6766 69.1043 80.8089C68.972 80.9411 68.8977 81.1205 68.8977 81.3076V83.4247H73.1281V81.3076C73.1281 81.2146 73.1097 81.1226 73.0741 81.0368C73.0384 80.951 72.9861 80.8731 72.9202 80.8075C72.8543 80.742 72.7761 80.6901 72.6901 80.6549C72.6041 80.6197 72.5119 80.6018 72.419 80.6023Z"
      fill="#FDF5FF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M86.1072 87.664C85.8748 87.6648 85.6459 87.6079 85.4408 87.4987C85.2357 87.3894 85.0608 87.2311 84.9318 87.0378C84.8027 86.8445 84.7236 86.6223 84.7013 86.3909C84.679 86.1596 84.7144 85.9264 84.8042 85.712C85.3554 84.6024 86.2054 83.6687 87.2586 83.0159C88.3117 82.3632 89.5261 82.0173 90.7651 82.0173C92.0041 82.0173 93.2186 82.3632 94.2717 83.0159C95.3248 83.6687 96.1748 84.6024 96.7261 85.712C96.8159 85.9265 96.8512 86.1598 96.8289 86.3913C96.8066 86.6227 96.7273 86.845 96.5981 87.0383C96.469 87.2316 96.2939 87.3899 96.0886 87.4991C95.8834 87.6083 95.6543 87.665 95.4218 87.664H86.1072Z"
      fill="#E6FBFF"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M90.7651 86.2471C90.7648 87.7441 90.17 89.1796 89.1114 90.2382C88.0529 91.2967 86.6173 91.8915 85.1203 91.8919H20.9104"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.8396 86.2471C49.8386 87.7426 49.2442 89.1766 48.1868 90.2343C47.1294 91.2919 45.6955 91.8867 44.2 91.888"
      stroke="#6A266D"
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
